import React, {useEffect, useRef,useState } from "react"; 
import { getEnvUrl,getToken } from "../../../utils/Api"; 
import Loader from "../../common/loader";
import CreateUser from "./popups/createUser";
import ViewUser from "./popups/viewUser";
import { checkPermissions } from "../../../Services/User/User";
import { useNavigate } from "react-router-dom";
const $ = require("jquery");
require("datatables.net");
const UsersList = ({ data }) => {
  const tableRef = useRef(null); 
  const [isLoading, setIsLoading] = useState(true);
  const [createUserModal, setCreateUserModal] = useState(false);
  const [editUserModal, setEditUserModal] = useState(false);
  const [rerender, setRetender] = useState(true);
  const [viewUserID, setViewUserID] = useState(false);
  const [viewSystemUserModal, setViewSystemUserModal] = useState(false);
  const viewSystemUserModalClose=()=>{setViewSystemUserModal(false)} 
  const navigate = useNavigate(); 
  const createUserModalClose=(rr=true)=>{
    setCreateUserModal(false)
    if(rr){
      setRetender(!rerender)
    } 
  }
  const editUserModalClose=(rr=true)=>{
    setEditUserModal(false)
    if(rr){
      setRetender(!rerender)
    } 
  }
  const [editUserId, setEditId] = useState(false);
   
  useEffect(() => {
  if(!checkPermissions('users_list_page') || !checkPermissions('users_navigation')){ 
      navigate('/')
    }
  },[])
  useEffect(() => {
    // Initialize DataTable
    const table = $(tableRef.current).DataTable({
      processing: true,
      serverSide: true,
      serverMethod: "get",
      ajax: {
        url: `${getEnvUrl()}/admin/user/userReport`,
        data:{from_date:'',to_date:''},
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      },
      columns: [
        { data: "id" },
      { data: "display_name" },
      { data: "email" },
      // { data: "country_code" },
      { data: "mobile_number" },
      { data: "active" },
      { data: "created_on"},      
      { 
        data: null,
        title: 'Actions',
        render:  (data, type, row) => (
          `<div> 
          <span class="a-edit"><i class="bi bi-pencil-square"></i></span>       
          <span class="a-view"><i class="bi bi-eye-fill"></i></span>
          </div>`
        )
          },
    ],
    createdRow: (row, data, dataIndex) => {  
      
      if(!checkPermissions('user_edit')){
        $(row).find('.a-edit').remove();
      }
    $(row).find('.a-edit').on('click', () => {setEditUserModal(true) 
    setEditId(data.id)});
      $(row).find('.a-view').on('click', () => {
        setViewSystemUserModal(true)
        setViewUserID(data.id)
      });
    },
      'columnDefs': [ {
        'targets': [6], /* column index */
        'orderable': false, /* true or false */
     }],
     drawCallback: function(settings) {
      setIsLoading(false);
    },
      aaSorting: [[0, "desc"]]
    });

    return () => {
      // Destroy DataTable when component unmounts to avoid memory leaks
      table.destroy();
    };
  }, [data,rerender]);

  
  return ( 
    <div> 
    <main id="main" className="main">
    <div className="pagetitle">
    <h1>Users List</h1> 
    </div>
    <section className="section">
        <div className="row">
          <div className="col-lg-12">
          <div className="card p-10"> 
            {checkPermissions ('user_create') && 
                <div className="col-sm-2 mb-2">
                  <button type="button" className="btn btn-primary" 
                  onClick={()=>setCreateUserModal(true)} >Add User</button>
              </div>
              }
              {isLoading?<Loader />:"" }
                  <div className={isLoading?'card-body hide':'card-body'}> 
                    <table
                      className="table table-striped table-hover table-bordered no-footer dataTable"
                      width="100%"
                      ref={tableRef}
                    >
                      <thead>
                      <tr>
                        <th>User id</th>
                        <th>Name</th>
                        <th>Email</th>
                        {/* <th>Country code</th> */}
                        <th>Phone Number</th>
                        <th>Active</th>
                        <th>CreatedOn</th>
                        <th>Action</th>
                      </tr>
                  </thead>
                    </table>
              </div>
            </div> 
            </div>
        </div>
      </section>
  </main>  
  {createUserModal?<CreateUser isShow={createUserModal} close={createUserModalClose} type="CREATE" />:''} 
  {editUserModal?<CreateUser isShow={editUserModal} close={editUserModalClose} userId={editUserId} type="EDIT"  />:''} 
  {viewSystemUserModal ? <ViewUser isShow={viewSystemUserModal} close={viewSystemUserModalClose} editUserId={viewUserID} /> : ''} 

 </div> 
  );
};
export default UsersList;
 
    